/* eslint-disable @typescript-eslint/typedef */
import { createAction } from '@reduxjs/toolkit';
import { Language } from '../../../Models/Enums/Language';

const setLanguage = createAction<Language>('preferences/setLanguage');

export default {
  setLanguage
};
